import { Header } from '@monorepo/shared/componentsV2/Header';
import { Loading } from '@monorepo/shared/componentsV2/Loading';
import { Main } from '@monorepo/shared/componentsV2/Main';
import { useCurrentProject } from '@monorepo/shared/hooks/useCurrentProject';
import {
  fillHeightAndScrollable,
  page,
  verticalLayout,
} from '@monorepo/shared/styles/layout';
import React, { useState } from 'react';
import styled from 'styled-components';

const Page = styled.div`
  ${verticalLayout}
  ${page}
`;

const StyledMain = styled(Main)`
  ${fillHeightAndScrollable}
  ${verticalLayout}
`;

const BackboneWrapper = styled.iframe`
  flex-grow: 1;
  margin-top: -1.75rem;
  margin-left: 0.375rem;
  border: none;
`;

export function SiteDetailsPage() {
  const [frameIsLoading, setFrameLoading] = useState(true);
  const { project } = useCurrentProject();

  return (
    <Page>
      <Header
        title="Site Details"
        subtitle={project?.name}
        variant="noDropShadow"
      />
      <StyledMain>
        {frameIsLoading && <Loading />}
        <BackboneWrapper
          src={`/project-settings/${project?.id}`}
          title="Site Details Section"
          onLoad={() => setFrameLoading(false)}
        />
      </StyledMain>
    </Page>
  );
}
